import type { $Fetch } from 'ofetch';
import type {
  Renegociacao, SolicitarRenegociacaoCommand, RenegociacaoDecisaoCommand, RenegociacaoStatus,
} from '@/domain/model/Renegociacao';
import type { Page } from '@/domain/model/Page';
import type { RenegociacaoGateway } from '@/application/port/out/RenegociacaoGateway';
import type { ApiResponse, SpringPage } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

const PATH = '/api/v1/commerce/renegociacoes';

export class HttpRenegociacaoGateway implements RenegociacaoGateway {
  constructor(private readonly client: $Fetch) {}

  async list(p: { status?: RenegociacaoStatus; parcelaId?: string; page?: number; size?: number }): Promise<Page<Renegociacao>> {
    const params: Record<string, string | number> = {};
    if (p.status) params['status'] = p.status;
    if (p.parcelaId) params['parcelaId'] = p.parcelaId;
    if (typeof p.page === 'number') params['page'] = p.page;
    if (typeof p.size === 'number') params['size'] = p.size;
    const res = await this.client<ApiResponse<SpringPage<Renegociacao>>>(PATH, { method: 'GET', params });
    assertApiSuccess(res);
    const d = res.data;
    return { content: d.content, number: d.number, size: d.size, totalElements: d.totalElements, totalPages: d.totalPages, first: d.first, last: d.last };
  }

  async get(id: string): Promise<Renegociacao> {
    const res = await this.client<ApiResponse<Renegociacao>>(`${PATH}/${encodeURIComponent(id)}`, { method: 'GET' });
    assertApiSuccess(res);
    return res.data;
  }

  async solicitar(command: SolicitarRenegociacaoCommand): Promise<Renegociacao> {
    const res = await this.client<ApiResponse<Renegociacao>>(PATH, { method: 'POST', body: command });
    assertApiSuccess(res);
    return res.data;
  }

  async decidir(id: string, command: RenegociacaoDecisaoCommand): Promise<Renegociacao> {
    const res = await this.client<ApiResponse<Renegociacao>>(
      `${PATH}/${encodeURIComponent(id)}/decidir`, { method: 'POST', body: command },
    );
    assertApiSuccess(res);
    return res.data;
  }
}
